import type { ReactElement } from 'react';
import * as React from 'react';
import { ALIGN, HeaderNavigation, StyledNavigationItem, StyledNavigationList } from 'baseui/header-navigation';
import { HeadingSmall } from 'baseui/typography';
import { LabelingSettings } from '../labeling-settings/labeling-settings';
type ThemeOptions = 'dark' | 'light' | 'system';
type PropsT = {
  title: string;
  userName: string;
  onThemeChange: (theme: ThemeOptions) => void;
  rightActionItems?: ReactElement;
};
export function Header({
  title,
  userName,
  onThemeChange,
  rightActionItems
}: PropsT) {
  return <HeaderNavigation overrides={{
    Root: {
      style: ({
        $theme
      }) => ({
        background: $theme.colors.backgroundPrimary,
        borderBottom: `2px solid ${$theme.colors.borderOpaque}`,
        paddingRight: $theme.sizing.scale500,
        height: $theme.sizing.scale1400,
        boxSizing: 'border-box'
      })
    }
  }}>
      <StyledNavigationList $align={ALIGN.left}>
        <StyledNavigationItem>
          <HeadingSmall>{title}</HeadingSmall>
        </StyledNavigationItem>
      </StyledNavigationList>

      <StyledNavigationList $align={ALIGN.center} />

      <StyledNavigationList $align={ALIGN.right}>
        {rightActionItems}
        <LabelingSettings userName={userName} onThemeChange={onThemeChange} />
      </StyledNavigationList>
    </HeaderNavigation>;
}